import React, { createContext, useContext } from "react";
import { CampaignEligibility, CampaignPrefillResponse } from "../types/campaignPrefill";

export interface CampaignPrefillContextValue {
  jobSpecificationId: number | null;
  prefill: CampaignPrefillResponse | null;
  eligibility: CampaignEligibility | null;
  isLoading: boolean;
  error: string | null;
}

const defaultValue: CampaignPrefillContextValue = {
  jobSpecificationId: null,
  prefill: null,
  eligibility: null,
  isLoading: false,
  error: null,
};

export const CampaignPrefillContext =
  createContext<CampaignPrefillContextValue>(defaultValue);

export const useCampaignPrefill = () => useContext(CampaignPrefillContext);

interface CampaignPrefillProviderProps {
  value: CampaignPrefillContextValue;
  children: React.ReactNode;
}

export const CampaignPrefillProvider: React.FC<CampaignPrefillProviderProps> = ({
  value,
  children,
}) => (
  <CampaignPrefillContext.Provider value={value}>
    {children}
  </CampaignPrefillContext.Provider>
);
